<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="General">
      <form class="edit-report-source-dialog-form">
        <mat-form-field>
          <mat-label>Name (required)</mat-label>
          <input matInput
                 name="reportSourceName"
                 [(ngModel)]="data.reportSource.name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Description</mat-label>
          <input matInput
                 name="description"
                 [(ngModel)]="data.reportSource.description" />
        </mat-form-field>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.preFilterCompanyAvailable" [(ngModel)]="data.reportSource.preFilterCompanyAvailable">PreFilter -- Allow Company Filtering</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.preFilterTitleAvailable" [(ngModel)]="data.reportSource.preFilterTitleAvailable">PreFilter -- Allow Title Filtering</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.preFilterRegionAvailable" [(ngModel)]="data.reportSource.preFilterRegionAvailable">PreFilter -- Allow Region Filtering</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.preFilterIndustryAvailable" [(ngModel)]="data.reportSource.preFilterIndustryAvailable">PreFilter -- Allow Industry Filtering</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.preFilterOccupationAvailable" [(ngModel)]="data.reportSource.preFilterOccupationAvailable">PreFilter -- Allow Occupation Filtering</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-checkbox name="data.reportSource.active" [(ngModel)]="data.reportSource.active">Active</mat-checkbox>
        </ng-container>
        <br />
        <ng-container>
          <mat-label>Report PBIX File: ({{ data.reportSource.fileName }})</mat-label>
          <input type="file"
                 id="inputFile"
                 (change)="handleFileInput($event.target.files)" />
        </ng-container>
        <ng-container *ngIf="uploadingReportSource">
          <b>Uploading Report, Please Wait....</b>
        </ng-container>
      </form>
    </mat-tab>
    <mat-tab label="Print on Demand Pages">
      <div class="row">
        <div class="col-md-2" style="text-align: center"><b>Order</b></div>
        <div class="col-md-4" style="text-align: center"><b>Display Name</b></div>
        <div class="col-md-4" style="text-align: center"><b>PBIX Page</b></div>
        <div class="col-md-2" style="text-align: center"><b>Action</b></div>
      </div>
      <ng-container *ngFor="let page of podData">
        <div class="row">
          <div class="col-md-2">
            <ng-container *ngIf="page.order !== 0">
              <a href="#" (click)="movePageUp(page)"><span class="fas fa-arrow-up" title="Move Page Up"></span></a>
            </ng-container>
            <ng-container *ngIf="page.order !== (podData.length - 1)">
              <a href="#" (click)="movePageDown(page)"><span class="fas fa-arrow-down" title="Move Page Down"></span></a>
            </ng-container>
          </div>
          <div class="col-md-4">
            <input matInput [(ngModel)]="page.displayName" placeholder="Display Name" />
          </div>
          <div class="col-md-4">
            <input matInput [(ngModel)]="page.page" placeholder="PBIX Name" />
          </div>
          <div class="col-md-2">
            <a href="#" (click)="removePage(page)"><span class="fas fa-trash" title="Delete Page"></span></a>
          </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <input matInput [(ngModel)]="newPageDisplayName" placeholder="Display Name" />
        </div>
        <div class="col-md-4">
          <input matInput [(ngModel)]="newPagePage" placeholder="PBIX Name" />
        </div>
        <div class="col-md-2">
          <a href="#" (click)="addPage()"><span class="fas fa-check" title="Add Page"></span></a>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          color="primary"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>

